/**
 * 数组arr中随机获取count个元素
 * @param arr 数组
 * @param count 元素个数
 * @return Array
 */
export const GetRandomArray = (arr, count) => {
    var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
    while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
    }
    return shuffled.slice(min);
}